//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  CAPTION_LENGTH_LIMIT,
  TIKTOK_MAX_VIDEO_DURATION_MILLIS,
  TIKTOK_MIN_DIMENSION_PX,
  TIKTOK_MIN_VIDEO_DURATION_MILLIS,
} from '@tiktok/redux/schedule/post-details/video-automatic/tiktokVideoAutomaticPostDetailsModel';
import { pluralize } from '@utils/stringUtils';

export const VERTICAL_ASPECT_RATIO = 9 / 16;
export const VIDEO_PREVIEW_WIDTH = 420;
export const VIDEO_PREVIEW_HEIGHT = Math.floor(
  VIDEO_PREVIEW_WIDTH / VERTICAL_ASPECT_RATIO,
);

export const PostDetailsHeaderText = {
  CreateVideoPost: 'Create Video Post',
  ReviewDraft: 'Review Draft',
  ReviewVideoPost: 'Review Video Post',
} as const;

export const CAPTION_LENGTH_REMAINING_WARNING_THRESHOLD = 20;

export const getCaptionTooLongErrorText = (charOverLimit: number) =>
  `A maximum of ${CAPTION_LENGTH_LIMIT} characters are allowed in the caption of a post. Please remove at least ${pluralize(
    charOverLimit,
    'character',
  )} to continue.`;

export const getRemainingText = (unitSingularForm: string, remaining: number) =>
  `${pluralize(remaining, unitSingularForm)} remaining`;

export const VideoAutomaticPostDetailsFormFieldErrorText = {
  InvalidThumbnailOffset: 'Please select a range within the video.',
  InvalidVideoDimensions: `The video you selected cannot be scheduled because it does not meet TikTok's minimum dimensions (${TIKTOK_MIN_DIMENSION_PX}px in height and ${TIKTOK_MIN_DIMENSION_PX}px in width)`,
  InvalidVideoDuration: `The video you selected cannot be scheduled because it does not meet TikTok's video length requirements (${
    TIKTOK_MIN_VIDEO_DURATION_MILLIS / 1000
  } to ${TIKTOK_MAX_VIDEO_DURATION_MILLIS / 1000} seconds)`,
  NoMedia: 'Please add media, or save as a draft.',
  NoScheduleTime: 'Please select a date and time, or save as a draft.',
  ScheduleTimeInPast:
    'Please select a post time in the future, or save as a draft.',
} as const;

export const VideoAutomaticPostDetailsFinalValidationErrorMessage =
  'Please address the errors above and try again.';

export const DATE_FORMAT = 'dddd, MMM. D';
export const TIME_FORMAT = 'h:mm A z';

export const TIKTOK_COVER_IMAGE_MODAL_VIDEO_WRAPPER_WIDTH = 300;
